import { useParams, Link } from 'react-router-dom';
import { Wrench } from 'lucide-react';
import { ScreenHeader } from '../../components/ui/ScreenHeader';
import { EmptyState } from '../../components/ui/EmptyState';
import { connectorCatalog } from '../../lib/connectors';

// Placeholder destination for a catalog card click (roadmap #9 Phase 1).
// The guided setup flow itself (GitHub fast path, generic-webhook visual
// Mapping editor) is a later slice - this screen exists only so the
// catalog never links to a 404. Anyone who lands here can still configure
// the connector today via the existing Advanced Mapping form.
export function IntegrationSetupPlaceholderScreen() {
  const { connectorId } = useParams<{ connectorId: string }>();
  const connector = connectorCatalog.find((c) => c.id === connectorId);

  return (
    <div className="flex flex-col gap-4">
      <ScreenHeader title={connector?.name ?? 'Connector'} backTo="/integrations/catalog" />
      <EmptyState
        icon={Wrench}
        title="Guided setup is coming soon"
        subtitle={
          connector
            ? `A step-by-step setup flow for ${connector.name} isn't built yet. For now, use the Advanced Mapping form to configure it directly.`
            : "A step-by-step setup flow isn't built yet. For now, use the Advanced Mapping form to configure a connector directly."
        }
      />
      <Link
        to="/mappings/new"
        className="self-center rounded-xl bg-blue-600 text-white px-4 py-2.5 text-sm font-semibold hover:bg-blue-700 transition-colors"
      >
        Open Advanced Mapping form
      </Link>
    </div>
  );
}
